import { DesignationEndpoints } from "../api/admin/designation.endpoints";
import APIrequest from "../lib/axios";

export const DesignationService = {
    async createDesignation(data) {
        try {
            const payload = {
                ...DesignationEndpoints.createDesignation,
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getAllDesignations() {
        try {
            const payload = {
                ...DesignationEndpoints.getAllDesignations,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getDesignation(id) {
        try {
            const payload = {
                ...DesignationEndpoints.getDesignation(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async updateDesignation(id, data) {
        try {
            const payload = {
                ...DesignationEndpoints.updateDesignation(id),
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async deleteDesignation(id) {
        try {
            const payload = {
                ...DesignationEndpoints.deleteDesignation(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
};
